import React from "react";
import { useTranslation } from "react-i18next";
import "./BridgeWaiting.css";

interface BridgeWaitingProps {
  provider: "vk";
  onCancel: () => void;
}

const PROVIDER_LABEL: Record<BridgeWaitingProps["provider"], string> = {
  vk: "VK",
};

const BridgeWaiting: React.FC<BridgeWaitingProps> = ({ provider, onCancel }) => {
  const { t } = useTranslation();
  return (
    <div className="bridge-waiting-overlay" data-testid="bridge-waiting">
      <div className="bridge-waiting-card">
        <div className="bridge-waiting-spinner" />
        <h3>{t("auth.bridgeWaitingTitle")}</h3>
        <p>{t("auth.bridgeWaitingBody", { provider: PROVIDER_LABEL[provider] })}</p>
        <button
          type="button"
          className="bridge-waiting-cancel"
          data-testid="bridge-cancel"
          onClick={onCancel}
        >
          {t("auth.cancel")}
        </button>
      </div>
    </div>
  );
};

export default BridgeWaiting;
